import { useEffect, useState } from "react";
import AgentSidebar from "./Commun/AgentSidebar";
import { AgentHeader } from "./Commun/AgentHeader";

import { AgentBookingCancle, AgentCancelReason, AgentDynamicVoucher, agentPropertylist, getagentBookingList } from "../Services/Service";

import swal from "sweetalert";
import { useProperty } from "../PropertyContext";
import "../reservation pages/Booking Details/BookingList.css";



export const AgentBookingList = () => {
    const { selectedProperty } = useProperty();

    const [bookingList, setBookingList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cancelCodes, setCancelCodes] = useState([]);
    const [selectedCode, setSelectedCode] = useState("");
    const [cancelReason, setCancelReason] = useState("");
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [properties, setProperties] = useState([]);
    const [selectedPID, setSelectedPID] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 15;



    // Property name Dropdown
    useEffect(() => {
        const FetchPropertyname = async () => {
            setLoading(true);
            try {
                const result = await agentPropertylist();
                setProperties(result);

                // Default select first property if available
                if (result.length > 0) {
                    setSelectedPID(result[0].PropertyID);
                }
            } catch (error) {
                console.log("Property not get from api", error);
            } finally {
                setLoading(false);
            }
        };
        FetchPropertyname();
    }, []);


    useEffect(() => {
        if (!selectedPID) return;
        const GetBookinglist = async () => {
            setLoading(true);
            try {
                const result = await getagentBookingList(selectedPID);
                setBookingList(result || []);
                setCurrentPage(1);
            } catch (error) {
                console.log("Error getting booking list", error);
            } finally {
                setLoading(false);
            }
        };
        GetBookinglist();
    }, [selectedPID]);


    // useEffect(() => {
    //     if (bookingList.length > 0 && window.$) {
    //         const table = window.$('.basic-datatables');

    //         // Check if already initialized
    //         if (window.$.fn.DataTable.isDataTable(table)) {
    //             table.DataTable().destroy(); // Destroy previous instance
    //         }

    //         setTimeout(() => {
    //             table.DataTable(); // Initialize new DataTable
    //         }, 0);
    //     }
    // }, [bookingList]);


    const handleGenerateVoucher = async (bonResId) => {
        try {
            setLoading(true);
            const data = await AgentDynamicVoucher(
                bonResId,
                selectedProperty?.PropertyID
            );

            const url = data?.url;
            if (!url) {
                alert("Voucher URL not found");
                return;
            }
            // 👉 Open in new tab (_blank)
            window.open(url, "_blank");

        } catch (error) {
            console.error("Voucher open failed:", error);
            alert("Failed to open voucher");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!selectedPID) return;

        const fetchCancelReason = async () => {
            try {
                const result = await AgentCancelReason(selectedPID);
                setCancelCodes(result || []);
            } catch (error) {
                console.log(
                    "Error fetching cancel reasons in Booking List page",
                    error
                );
            }
        };

        fetchCancelReason();
    }, [selectedPID]);

    const handleCodeChange = (e) => {
        const code = e.target.value;
        setSelectedCode(code);

        const selected = cancelCodes.find((c) => c.Code === code);
        if (selected) {
            setCancelReason(selected.Description);
        } else {
            setCancelReason("");
        }
    };

    // reset form
    const resetCancelForm = () => {
        setSelectedCode("");
        setCancelReason("");
        setSelectedBooking(null);
    };

    // booking cancle
    const handleCancelBooking = async (booking) => {

        if (!selectedCode) {
            alert("Please select a cancellation code.");
            return;
        }

        if (!cancelReason) {
            alert("Please enter a reason.");
            return;
        }



        setLoading(true);
        try {
            const result = await AgentBookingCancle(booking.BONRESID, selectedPID, selectedCode, cancelReason);

            if (result && result.BONRESID) {
                swal("Booking cancelled successfully!", {
                    icon: "success",
                    buttons: {
                        confirm: {
                            text: "OK",
                            className: "btn btn-success",
                        },
                    },
                }).then(() => {

                    const modal = window.bootstrap.Modal.getInstance(
                        document.getElementById("Cancel-Booking-Resion")
                    );
                    if (modal) modal.hide();

                    resetCancelForm(); // reset fields
                });

                // Table update: remove cancelled booking ya fetch list again
                setBookingList((prev) =>
                    prev.map((b) =>
                        b.BONRESID === booking.BONRESID ? { ...b, BookingStatus: "Cancelled" } : b
                    )
                );

            } else {
                alert(result?.message || "Failed to cancel booking");
            }
        } catch (error) {
            console.error(error);
            alert("Error cancelling booking");
        } finally {
            setLoading(false);
        }

    };

    const totalRows = bookingList.length;
    const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage));
    const safeCurrentPage = Math.min(currentPage, totalPages);
    const firstRow = totalRows === 0 ? 0 : ((safeCurrentPage - 1) * rowsPerPage) + 1;
    const lastRow = Math.min(safeCurrentPage * rowsPerPage, totalRows);
    const visibleBookings = bookingList.slice(firstRow ? firstRow - 1 : 0, lastRow);
    const pageStart = Math.min(
        Math.max(safeCurrentPage - 1, 1),
        Math.max(totalPages - 2, 1)
    );
    const visiblePages = Array.from(
        { length: Math.min(3, totalPages) },
        (_, index) => pageStart + index
    );
    return (
        <>

            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x" role="status"></div>
                </div>
            )}

            <div className="wrapper">
                <AgentSidebar />
                <div className="main-panel">
                    <AgentHeader />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-sm-5">
                                    <div className="input-block mb-3">
                                        <select
                                            className="form-control form-select"
                                            value={selectedPID}
                                            onChange={(e) => setSelectedPID(e.target.value)}
                                        >
                                            {properties.map((property) => (
                                                <option key={property.PropertyID} value={property.PropertyID}>
                                                    {property.PropertyName}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="booking-list-card card">
                                        <div className="booking-list-header card-header">
                                            <h4 className="card-title">Agent Booking List</h4>
                                        </div>
                                        <div className="card-body p-0">
                                            <div className="booking-list-table-wrap table-responsive">
                                                <table
                                                    // id="basic-datatables"
                                                    className="display table table-striped table-hover basic-datatables" style={{ whiteSpace: "nowrap" }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>sr#</th>
                                                            <th>Bon ref. id</th>
                                                            <th>pms id</th>
                                                            <th>check-in</th>
                                                            <th>check-out</th>
                                                            <th>guest info</th>
                                                            <th>payment</th>
                                                            <th>status</th>
                                                            <th>book on</th>
                                                            <th>action</th>

                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {visibleBookings.length > 0 ? (
                                                            visibleBookings.map((booking, index) => (
                                                                <tr key={booking.BONRESID || index}>
                                                                    <td>{firstRow + index}</td>
                                                                    <td className="booking-reference">{booking.BONRESID || "N/A"}</td>
                                                                    <td>{booking.PMSRESID || "N/A"}</td>
                                                                    <td>

                                                                        {booking.CheckInDate || "N/A"}

                                                                    </td>
                                                                    <td>
                                                                        {booking.CheckOutDate || "N/A"}


                                                                    </td>
                                                                    <td>{booking.GuestName || "N/A"}</td>
                                                                    <td>
                                                                        ₹{booking.TotalPayment || 0}
                                                                        <div>
                                                                            {" "}
                                                                            <span
                                                                                className={
                                                                                    booking.PaymentStatus === "Paid"
                                                                                        ? "text-success"
                                                                                        : booking.PaymentStatus === "Pending"
                                                                                            ? "text-warning"
                                                                                            : "text-secondary"
                                                                                }
                                                                            >
                                                                                {booking.PaymentStatus || "N/A"}
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <span
                                                                            className={
                                                                                booking.BookingStatus === "Confirmed"
                                                                                    ? "text-success"
                                                                                    : booking.BookingStatus === "Pending"
                                                                                        ? "text-warning"
                                                                                        : booking.BookingStatus === "Cancelled"
                                                                                            ? "text-danger"
                                                                                            : "text-secondary"
                                                                            }
                                                                        >
                                                                            {booking.BookingStatus || "N/A"}
                                                                        </span>
                                                                    </td>
                                                                    <td>{booking.BookingDate || "N/A"}</td>
                                                                    <td className="text-center">
                                                                        <div className="dropdown dropdown-action">
                                                                            <a
                                                                                href="/"
                                                                                className="action-icon"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                            >
                                                                                <i className="fas fa-ellipsis-v" style={{ color: "#333" }}></i>
                                                                            </a>
                                                                            <div className="dropdown-menu dropdown-menu-right">
                                                                                {/* <button className="dropdown-item">
                                                                                    <i className="fas fa-edit me-2"></i>
                                                                                    Modify
                                                                                </button > */}
                                                                                {booking.BookingStatus !== "Cancelled" && (
                                                                                    // <button className="dropdown-item" type='button' onClick={() => handleCancelBooking(item)}><i className='fas fa-ban me-1'></i> Cancelled </button>
                                                                                    <button type="button" className="dropdown-item" data-bs-toggle="modal"
                                                                                        data-bs-target="#Cancel-Booking-Resion" onClick={() => {
                                                                                            setSelectedBooking(booking); setSelectedCode(""); // reset code
                                                                                            setCancelReason("");
                                                                                        }} ><i className='fas fa-ban me-2'></i>Cancelled</button>
                                                                                )}
                                                                                <button className="dropdown-item"
                                                                                    // onClick={() => handleVoucherPDF(booking)}
                                                                                    onClick={() => handleGenerateVoucher(booking.BONRESID)}>
                                                                                    <i className="fas fa-sticky-note me-2"></i>
                                                                                    Booking Voucher
                                                                                </button>
                                                                                {/* <button className="dropdown-item" o>
                                                                                    <i className="fas fa-sticky-note me-2"></i>
                                                                                    Booking Voucher
                                                                                </button> */}
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="10" className="text-center">
                                                                    No bookings found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                </table>
                                            </div>
                                            <div className="booking-pagination">
                                                <span>
                                                    Showing {firstRow} to {lastRow} of {totalRows} entries
                                                </span>
                                                <nav aria-label="Agent booking list pagination">
                                                    <button type="button" aria-label="Previous page" disabled={safeCurrentPage === 1} onClick={() => setCurrentPage(page => Math.max(1, page - 1))}>
                                                        &lsaquo;
                                                    </button>
                                                    {visiblePages.map(page => (
                                                        <button type="button" key={page} className={page === safeCurrentPage ? "active" : ""} aria-current={page === safeCurrentPage ? "page" : undefined} onClick={() => setCurrentPage(page)}>
                                                            {page}
                                                        </button>
                                                    ))}
                                                    <button type="button" aria-label="Next page" disabled={safeCurrentPage === totalPages} onClick={() => setCurrentPage(page => Math.min(totalPages, page + 1))}>
                                                        &rsaquo;
                                                    </button>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="modal fade"
                                id="Cancel-Booking-Resion"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title" id="exampleModalLabel">
                                                Booking Cancel
                                            </h4>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">

                                            <div className="mb-3">
                                                <label className="col-form-label">Code:</label>
                                                <select className="form-control form-select" value={selectedCode}
                                                    onChange={handleCodeChange}>
                                                    <option>Select Code</option>
                                                    {cancelCodes.map((c) => (
                                                        <option key={c.Code} value={c.Code}>
                                                            {c.Code}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="" className="col-form-label">
                                                    Cancel Reason:
                                                </label>
                                                <textarea className="form-control" value={cancelReason}
                                                    onChange={(e) => setCancelReason(e.target.value)} />
                                            </div>

                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" onClick={() => handleCancelBooking(selectedBooking)} className="btn btn-danger">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}
